module.exports = __webpack_public_path__ + "img/prop-sign-2-left.91b87519.png";